const backgroundImage = require( './background.jpg' );

export default {
  backgroundImage,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/static/index.ts